export const plans = {
    15: 500,
    16: 500,
    17: 1000,
    18: 2000
}